import Contact from '../components/pages/Contact/Contact';
export default Contact;
